import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { SpinnerLoading } from '../components/SpinnerLoading/SpinnerLoading';
import { ROUTE } from '../constants/routes';

interface AuthorizeParms extends RouteProps {
  isEnabled: boolean;
  isLoading?: boolean;
  redirect?: string;
}

export const AuthorizedRoute = ({
  isEnabled,
  isLoading,
  redirect = ROUTE.Home,
  children,
  ...rest
}: AuthorizeParms): JSX.Element => {
  const content = () => {
    if (isLoading) return <SpinnerLoading />;
    if (isEnabled) return children;
    return <Redirect to={redirect} />;
  };

  return <Route {...rest}>{content()}</Route>;
};
